import { S25ItemI } from "./S25ItemI";
import { Proto } from "./Proto";
import NumericalBoolean = Proto.NumericalBoolean;

export namespace EventQuota {
    export type DurationNameMap = {
        D: "Day";
        W: "Week";
        M: "Month";
        Y: "Year";
    };

    export const durationNameMap: DurationNameMap = { D: "Day", W: "Week", M: "Month", Y: "Year" };

    // Interface for raw JSON quota data from server
    export interface RawData {
        quota_id: number;
        quota_name: string;
        comment?: string;
        active: boolean;
        quota_type: number;
        quantity: number;
        duration: number;
        max_minutes: number;
        duration_type: keyof DurationNameMap;
        group_objects: number;
        skip_existing: number;
        itemIds?: S25ItemI[];
        organizations?: S25ItemI[];
        locations?: S25ItemI[];
        secGroups?: S25ItemI[];
        [key: string]: any; // Allow additional properties
    }

    // Interface for JSON output when converting from Detailed to JSON
    export interface JsonOutput {
        _status: string;
        active?: boolean;
        quota_id?: number;
        quota_name?: string;
        comment?: string;
        quota_type: number;
        quantity: number;
        max_minutes?: number;
        duration?: number;
        duration_type?: string;
        group_objects: number;
        skip_existing: number;
        organizations: S25ItemI[];
        locations: S25ItemI[];
        secGroups: Array<{ itemId: number; _status: string }>;
    }

    export interface Detailed {
        itemId?: number;
        itemName?: string;
        type?: S25ItemI;
        duration?: number;
        durationType?: string;
        durationTypeName?: string;
        useQuantity?: boolean; //Indicates whether quota is count based or time based
        quantity?: number;
        maxTime?: string; //ISODuration
        groupItems?: boolean; //Indicates whether limitation are applied individually or by the group of items
        skipExisting?: boolean; //Quota only applies to this event - requested for embedded and 'guest' events
        organizations?: S25ItemI[]; //Array of locations or organizations
        locations?: S25ItemI[]; //Array of locations or organizations
        securityGroups?: S25ItemI[];
        active?: boolean;
        comment?: string;
        status?: string; // Added for objToJson method
        items?: S25ItemI[]; // Added based on usage in jsonToObj
        secGroups?: S25ItemI[]; // Added based on usage in jsonToObj
        // Properties for multiselect status tracking
        addedLocations?: S25ItemI[];
        removedLocations?: S25ItemI[];
        addedOrgs?: S25ItemI[];
        removedOrgs?: S25ItemI[];
        addedGroups?: S25ItemI[];
        removedGroups?: S25ItemI[];
        [key: string]: any; //allow any other properties
    }

    export interface Type {
        itemId: number;
        itemName: string;
    }

    export const enum TypeIds {
        System = 99, // deprecated
        Location = 4, // deprecated, "User"
        User = 3,
        Organization = 2,
    }

    // Interfaces for quota checking functionality
    export interface CheckOccurrence {
        allowed: NumericalBoolean;
        allowed_time: NumericalBoolean;
        allowed_count: NumericalBoolean;
        uuid: string;
        rsrvId: number;
        startDt: Date;
        endDt: Date;
        object_id: number;
        object_type_id: number;
        location?: S25ItemI;
    }

    export interface CheckResult {
        quota: Detailed & {
            subjectTypeId: number;
            subjectTypeName: string;
        };
        occ: CheckOccurrence;
    }

    export interface LocationItem extends S25ItemI {
        occ_id?: string;
        itemTypeId: 4;
    }
}

// Type aliases for backward compatibility
export type EventQuotaDetailedI = EventQuota.Detailed;
